import Vue from 'vue';
import Rollbar from 'rollbar';
import CONF from '@/_oad_repo/config';

// Set the Rollbar instance in the Vue prototype
// before creating the first Vue instance.
// This ensures it is available in the same way for every
// instance in your app.
// Vue Router 3 throws an Error whenever a navigation is interrupted by a
// new push() or by a beforeEach guard redirect. These are normal user
// behaviour (rapid clicking, auth-redirect) — not bugs. Filter them at the
// SDK so they never reach Rollbar. (Rollbar Sproule #40, #38, #35, #53.)
const NAV_NOISE = [
    /Navigation cancelled from /i,
    /Avoided redundant navigation /i,
    /Redirected when going from /i,
    /NavigationDuplicated/i,
];

Vue.prototype.$rollbar = new Rollbar({
    accessToken: CONF.ROLLBACK_TOKEN_JS,
    environment: CONF.ROLLBACK_ENV,
    captureUncaught: true,
    captureUnhandledRejections: true,
    checkIgnore: function (isUncaught, args, payload) {
        try {
            const msg = (payload && payload.body && payload.body.trace
                && payload.body.trace.exception
                && payload.body.trace.exception.message) || '';
            const arg0 = (args && args[0]) || '';
            const text = String(msg) + ' ' + (arg0 && arg0.message ? arg0.message : String(arg0));
            return NAV_NOISE.some(re => re.test(text));
        } catch (e) {
            return false;
        }
    },
});

// If you have already set up a global error handler,
// just add `vm.$rollbar.error(err)` to the top of it.
// If not, this simple example will preserve the app’s existing
// behavior while also reporting uncaught errors to Rollbar.
Vue.config.errorHandler = (err, vm, info) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
};